import type { FC } from "react";
import type { Control } from "react-hook-form";
import type {
	NewContractFormInput,
	NewContractFormOutput,
} from "web_myplann/Goals/Forms/newContractFormSchema";
import type { NewContractType } from "web_myplann/Goals/Types/NewContractType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useProducerProductOptions } from "web_myplann/Portfolio/Helpers/useProducerProductOptions";
import { DisclosureSection } from "web_myplann/Shared/Components/DisclosureSection";
import { FlatRowFormCombobox } from "web_myplann/Shared/Components/FlatRow/FlatRowFormCombobox";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";

const PageResources = Resources.Goals.Detail.Solution.Pin.New;

type Props = {
	control: Control<NewContractFormInput, unknown, NewContractFormOutput>;
	type: NewContractType;
};

export const NewContractOptionalFields: FC<Props> = ({ control, type }) => {
	const { t } = useResource();

	const { producerOptions, productOptions, isLoadingProducts } =
		useProducerProductOptions(control, type);

	return (
		<DisclosureSection
			labelCollapsed={t(PageResources.showOptional)}
			labelExpanded={t(PageResources.hideOptional)}
		>
			<FlatRowFormInput
				control={control}
				name="contractNumber"
				label={t(PageResources.contractNumberLabel)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.optional)}
				maxLength={ValidationLimits.TextLength.Name}
			/>
			<FlatRowFormCombobox
				control={control}
				name="producer"
				label={t(PageResources.producerLabel)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.optional)}
				searchPlaceholder={t(
					Resources.Portfolio.AddShared.Placeholders.searchOrEnterProducer,
				)}
				options={producerOptions}
			/>
			<FlatRowFormCombobox
				control={control}
				name="product"
				label={t(PageResources.productLabel)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.select)}
				searchPlaceholder={t(
					Resources.Portfolio.AddShared.Placeholders.searchOrEnterProduct,
				)}
				options={productOptions}
				isLoading={isLoadingProducts}
			/>
		</DisclosureSection>
	);
};
